// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__iQmjr","slider":"styles_slider__U_myj","disabled":"styles_disabled__NmITI"};